module.exports = __webpack_public_path__ + "img/account.4c202db7.svg";